export default function () {
    // Слайдер
const slides = document.querySelectorAll('.slide');
const dotsContainer = document.querySelector('.dots');
const prevBtn = document.querySelector('.prev');
const nextBtn = document.querySelector('.next');

let currentSlide = 0;
let autoplayInterval;
let autoplayDelay = 3000; // Значение по умолчанию - 3 секунды

// Получаем интервал из атрибута data-autoplay-interval у контейнера слайдера
const sliderContainer = document.querySelector('.slider') || document.body;
const autoplayIntervalAttr = sliderContainer.getAttribute('data-autoplay-interval');

if (autoplayIntervalAttr && !isNaN(autoplayIntervalAttr)) {
    autoplayDelay = parseInt(autoplayIntervalAttr);
}

// Создаем точки для слайдера
slides.forEach((slide, index) => {
    const dot = document.createElement('span');
    dot.classList.add('dot');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => {
        goToSlide(index);
        resetAutoplay();
    });
    dotsContainer.appendChild(dot);
});

const dots = document.querySelectorAll('.dot');

function goToSlide(slideIndex) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');

    currentSlide = (slideIndex + slides.length) % slides.length;

    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
}

function nextSlide() {
    goToSlide(currentSlide + 1);
    resetAutoplay();
}

function prevSlide() {
    goToSlide(currentSlide - 1);
    resetAutoplay();
}

function startAutoplay() {
    stopAutoplay(); // Останавливаем предыдущий интервал, если был
    autoplayInterval = setInterval(() => {
        nextSlide();
    }, autoplayDelay);
}

function stopAutoplay() {
    if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
    }
}

function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
}

// Назначаем обработчики кнопок
nextBtn.addEventListener('click', nextSlide);
prevBtn.addEventListener('click', prevSlide);

// Запускаем автоплей
startAutoplay();

// Останавливаем автоплей при наведении мыши на слайдер
sliderContainer.addEventListener('mouseenter', stopAutoplay);
sliderContainer.addEventListener('mouseleave', startAutoplay);

}